// ----------------------------------------------------------------------

export const toasterClasses = {
    root: "toaster__root",
    toast: "toaster__toast",
    title: "toaster__title",
    icon: "toaster__icon",
    iconSvg: "toaster__icon__svg",
    content: "toaster__content",
    description: "toaster__description",
    actionButton: "toaster__action__button",
    cancelButton: "toaster__cancel__button",
    closeButton: "toaster__close_button",
    loadingIcon: "toaster__loading_icon",
    //
    default: "toaster__default",
    error: "toaster__error",
    success: "toaster__success",
    warning: "toaster__warning",
    info: "toaster__info",
    //
    loader: "sonner-loader",
    loaderVisible: '&[data-visible="true"]',
    closeBtnVisible: '[data-close-button="true"]',
}
